import React, { Fragment, useState, useEffect } from "react";
import Link from "next/link";
import API from "@unisearch/helpers/api";
import { getAssets } from "@unisearch/helpers";
import styles from "./recent_post.module.scss";
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import Image from "next/image";
import SkeletonRecentBlog from "@modules/skeleton/recent_blog";

export const BlogRecentPost = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get("/public/blog-page/latest-post?limit=5");
        setLoading(false);
        setPosts(res.data);
      } catch (error) {}
    };
    fetchData();
  }, []);

  let content;
  if (loading) {
    content = <SkeletonRecentBlog />;
  }
  if (!loading) {
    content = (
      <Fragment>
        {posts?.length > 0 && (
          <div className={styles.recent_post_wrapper}>
            <h5>Recent Posts</h5>
            <div className={styles.recent_post_lists}>
              {posts?.map((item, i) => {
                return (
                  <div className="grid grid-cols-[100px_1fr] gap-2" key={i}>
                    <div className={`relative`}>
                      <Link href={`/blog/${item?.slug}` || "#"}>
                        <Image
                          width={150}
                          height={150}
                          className="rounded"
                          blurDataURL={getAssets(
                            "assets/images/image_placeholder_big.webp"
                          )}
                          placeholder="blur"
                          src={
                            item?.featureImageSrc ||
                            getAssets(
                              "assets/images/image_placeholder_big.webp"
                            )
                          }
                          alt={item?.blogTitle || "recent blog"}
                        />
                        {item?.videoType && (
                          <PlayButtonWithRipple small ripple={false} />
                        )}
                      </Link>
                    </div>

                    <div className={styles.desc_wrapper}>
                      <Link href={`/blog/${item?.slug}` || "#"}>
                        <h5 className="text-sm block leading-[1.5] !mb-1 font-semibold line-clamp-2 hover:text-[#f47f20] transition-all">
                          {item?.blogTitle}
                        </h5>
                      </Link>

                      <div className="text-xs flex items-center gap-1.5">
                        <span>
                          {item?.publishDate && item?.publishDate.substr(0, 10)}
                        </span>
                        <span className="w-[6px] h-[6px] rounded-full bg-gray-400"></span>
                        <span>{item?.readingTime} min read</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
  return <Fragment>{content}</Fragment>;
};

export default BlogRecentPost;
